import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  bulletContainer: { flexDirection: 'row' },
  bullet: {
    width: 7,
    height: 7,
    marginHorizontal: 12,
    marginVertical: 7,
    borderRadius: 30,
    backgroundColor: neutrals.black,
  },
  text: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 20,
    color: neutrals.black,
  },

  knowMoreWrapper: {
    display: 'block',
  },
  knowMoreLink: {
    display: 'inline',
  },
});
